import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/Index/Index'
import Login from '@/components/Login/Login'
import Vehicle from '@/components/Vehicle/Vehicle'
import Vehicles from '@/components/Vehicles/Vehicles'
import Sessions from '@/components/Sessions/Sessions'
import Session from '@/components/Session/Session'
import Calibrations from '@/components/Calibrations/Calibrations'
import NewCalibration from '@/components/NewCalibration/NewCalibration'
import Demo from '@/components/Demo/Demo'

import store from '../store'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) return next()
  return next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) return next()
  return next('/login')
}

const ifStaff = (to, from, next) => {
  if (store.getters.isStaff) return next()
  return next('/')
}

const ifDemo = (to, from, next) => {
  if (location.hostname === 'localhost'
    || location.hostname === 'acceptance.emissionmonitor.eu'
    || location.hostname === 'demo.emissionmonitor.eu') {
    return next()
  }
  return next('/')
}

const router = new Router({
  mode: 'history',
  routes: [
    { path: '*', redirect: '/' },
    {
      path: '/',
      name: 'Index',
      component: Index,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/vehicles',
      name: 'Vehicles',
      component: Vehicles,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/vehicles/:id',
      name: 'Vehicle',
      component: Vehicle,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/sessions',
      name: 'Sessions',
      component: Sessions,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/sessions/:id',
      name: 'Session',
      component: Session,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/calibrations',
      name: 'Calibrations',
      component: Calibrations,
      beforeEnter: ifAuthenticated && ifStaff
    },
    {
      path: '/calibrations/new',
      name: 'NewCalibration',
      component: NewCalibration,
      beforeEnter: ifAuthenticated && ifStaff
    },
    {
      path: '/demo',
      name: 'Demo',
      component: Demo,
      beforeEnter: ifDemo
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js